import { useEffect, useState } from "react";
import {
  getTournamentDetail,
  registerTournament,
  TournamentRequest,
  updateTournament,
} from "../../../api/tournament";
import { useRecoilValue } from "recoil";
import { pubState } from "../../../recoil/pub.atom";
import {
  isDailyType,
  isEventType,
  isGTDType,
} from "../../../utils/tournament-type";
import {
  getYoutubeLive,
  YoutubeLiveRequest,
  YoutubeLiveResponse,
} from "../../../api/youtube-live";
import {
  updateTournamentPreset,
  registerTournamentPreset,
} from "../../../api/tournament-preset";
import { isTournamentAccess } from "../../../utils/owner";

const defaultStructures = [
  {
    level: 1,
    time: 10,
    smallBlind: 500,
    bigBlind: 1000,
    ante: 0,
    type: "LEVEL",
    ord: 1,
  },
  {
    level: 2,
    time: 10,
    smallBlind: 1000,
    bigBlind: 2000,
    ante: 0,
    type: "LEVEL",
    ord: 2,
  },
  {
    level: 3,
    time: 10,
    smallBlind: 2000,
    bigBlind: 4000,
    ante: 0,
    type: "LEVEL",
    ord: 3,
  },
  {
    level: 4,
    time: 10,
    smallBlind: 4000,
    bigBlind: 8000,
    ante: 0,
    type: "LEVEL",
    ord: 4,
  },
  {
    time: 10,
    removeChip: 0,
    type: "BREAK",
    ord: 5,
  },
  {
    level: 5,
    time: 10,
    smallBlind: 8000,
    bigBlind: 16000,
    ante: 0,
    type: "LEVEL",
    ord: 6,
  },
  {
    level: 6,
    time: 10,
    smallBlind: 16000,
    bigBlind: 32000,
    ante: 0,
    type: "LEVEL",
    ord: 7,
  },
  {
    level: 7,
    time: 10,
    smallBlind: 32000,
    bigBlind: 64000,
    ante: 0,
    type: "LEVEL",
    ord: 8,
  },
  {
    level: 8,
    time: 10,
    smallBlind: 64000,
    bigBlind: 128000,
    ante: 0,
    type: "LEVEL",
    ord: 9,
  },
  {
    time: 10,
    removeChip: 0,
    type: "BREAK",
    ord: 10,
  },
  {
    level: 9,
    time: 10,
    smallBlind: 128000,
    bigBlind: 256000,
    ante: 0,
    type: "LEVEL",
    ord: 11,
  },
  {
    level: 10,
    time: 10,
    smallBlind: 1000,
    bigBlind: 2000,
    ante: 0,
    type: "LEVEL",
    ord: 12,
  },
  {
    level: 11,
    time: 10,
    smallBlind: 2000,
    bigBlind: 4000,
    ante: 0,
    type: "LEVEL",
    ord: 13,
  },
  {
    level: 12,
    time: 10,
    smallBlind: 4000,
    bigBlind: 8000,
    ante: 0,
    type: "LEVEL",
    ord: 14,
  },
  {
    time: 10,
    removeChip: 0,
    type: "BREAK",
    ord: 15,
  },
  {
    level: 13,
    time: 10,
    smallBlind: 500,
    bigBlind: 1000,
    ante: 0,
    type: "LEVEL",
    ord: 16,
  },
  {
    level: 14,
    time: 10,
    smallBlind: 1000,
    bigBlind: 2000,
    ante: 0,
    type: "LEVEL",
    ord: 17,
  },
  {
    level: 15,
    time: 10,
    smallBlind: 2000,
    bigBlind: 4000,
    ante: 0,
    type: "LEVEL",
    ord: 18,
  },
  {
    level: 16,
    time: 10,
    smallBlind: 4000,
    bigBlind: 8000,
    ante: 0,
    type: "LEVEL",
    ord: 19,
  },
  {
    time: 10,
    removeChip: 0,
    type: "BREAK",
    ord: 20,
  },
  {
    level: 17,
    time: 10,
    smallBlind: 500,
    bigBlind: 1000,
    ante: 0,
    type: "LEVEL",
    ord: 21,
  },
  {
    level: 18,
    time: 10,
    smallBlind: 1000,
    bigBlind: 2000,
    ante: 0,
    type: "LEVEL",
    ord: 22,
  },
  {
    level: 19,
    time: 10,
    smallBlind: 2000,
    bigBlind: 4000,
    ante: 0,
    type: "LEVEL",
    ord: 23,
  },
  {
    level: 20,
    time: 10,
    smallBlind: 4000,
    bigBlind: 8000,
    ante: 0,
    type: "LEVEL",
    ord: 24,
  },
];

export enum TournamentType {
  Tournament = "TOURNAMENT",
  Daily = "DAILY",
  Milestone = "MILESTONE",
  TimeAttack = "TIME_ATTACK",
}

export enum ReBuyInType {
  INDIVIDUAL = "INDIVIDUAL",
  SHARE = "SHARE",
}

export enum EarlyChipSettingType {
  NONE = "NONE",
  USER_LIMIT = "USER_LIMIT",
  LEVEL_LIMIT = "LEVEL_LIMIT",
}

export interface LevelLimitChip {
  level: number;
  chip: number;
  id?: number;
}

export interface TournamentDiscount {
  level: number;
  amount: number;
  id?: number;
}

export interface MoneyInChip {
  rank: number;
  point: number;
  subPrize: string;
  prizeType?: string | null;
  id?: number;
  isSubPrize: boolean;
}

export enum PrizeType {
  FREE_TICKET = "FREE_TICKET",
  MONEY = "MONEY",
}

export interface StructuresResponse {
  type: string;
  level?: number;
  time: number;
  smallBlind?: number;
  bigBlind?: number;
  ante?: number;
  removeChip?: number;
  id?: number;
  ord: number;
}

export interface MenuColor {
  backgroundImage: string;
  fontColor: string;
  menu1Color: string;
  menu2Color: string;
  menu3Color: string;
  menu4Color: string;
  menu5Color: string;
  menu6Color: string;
  boxColor: string;
  buttonColor: string;
}

export interface MenuColorResponse extends MenuColor {
  tournamentId: number;
}

export interface AddPrize {
  rank: number;
  prize: number;
}

export const useEditTournament = () => {
  const now = new Date();
  const pub = useRecoilValue(pubState);
  const [tournamentId, setTournamentId] = useState<number | null>(null);
  const [selectedPresetId, setSelectedPresetId] = useState<number | null>(null);
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [tournamentType, setTournamentType] = useState<TournamentType>(
    TournamentType.Tournament,
  );
  // 토너먼트 시작일
  const [startDate, setStartDate] = useState("");
  const [startTime, setStartTime] = useState(
    `${now.getHours()}:${now.getMinutes()}`,
  );
  // 참가 설정
  const [entry, setEntry] = useState(0); // 기준 엔트리
  const [buyIn, setBuyIn] = useState(30000);
  const [reBuyIn, setReBuyIn] = useState(30000);
  const [addOn, setAddOn] = useState(30000);
  const [buyInChip, setBuyInChip] = useState(50000);
  const [reBuyInChip, setReBuyInChip] = useState(50000);
  const [adOnChip, setAdOnChip] = useState(50000);
  const [isFreezeOut, setIsFreezeOut] = useState(false); // 프리즈 아웃

  // 레지마감 레벨
  const [registerDeadlineLevel, setRegisterDeadlineLevel] = useState(0);

  // 얼리버드 설정
  const [earlyChipSetting, setEarlyChipSetting] =
    useState<EarlyChipSettingType>(EarlyChipSettingType.NONE);
  const [userLimit, setUserLimit] = useState<number>(10); // 인원제한 얼리버드
  const [earlyInChip, setEarlyInChip] = useState(60000); // 인원제한 얼리버드
  const [levelLimitChip, setLevelLimitChip] = useState<LevelLimitChip[]>([
    { level: 1, chip: 0 },
    { level: 2, chip: 0 },
    { level: 3, chip: 0 },
  ]); // 레벨제한 얼리버드

  // 현재 엔트리 수
  const [entryUserCount, setEntryUserCount] = useState<number>(0);

  // 토너먼트 할인 설정
  const [isTournamentDiscount, setIsTournamentDiscount] = useState(false);
  const [tournamentDiscounts, setTournamentDiscounts] = useState<
    TournamentDiscount[]
  >([
    { level: 1, amount: 0 },
    { level: 2, amount: 0 },
    { level: 3, amount: 0 },
  ]);

  // 데일리 토너먼트 할인 제외
  const [isDiscountExcluded, setIsDiscountExcluded] = useState<boolean>(false);
  const [totalDiscount, setTotalDiscount] = useState<number>(0); // 현재 총 할인 금액

  // 추가 시상
  const [additionalList, setAdditionalList] = useState<AddPrize[]>([]);
  const [additional, setAdditional] = useState<number>(80); // 추가시상 비율
  const [isAdditional, setIsAdditional] = useState<boolean>(false); // 추가시상 여부

  // 프라이즈 설정
  const [moneyInChip, setMoneyInChip] = useState<MoneyInChip[]>([
    { rank: 1, point: 0, subPrize: "", prizeType: null, isSubPrize: false },
    { rank: 2, point: 0, subPrize: "", prizeType: null, isSubPrize: false },
    { rank: 3, point: 0, subPrize: "", prizeType: null, isSubPrize: false },
    { rank: 4, point: 0, subPrize: "", prizeType: null, isSubPrize: false },
    { rank: 5, point: 0, subPrize: "", prizeType: null, isSubPrize: false },
  ]);
  const [prizeType, setPrizeType] = useState("SEED"); // 프라이즈 단위 ('SEED' | '%')
  const [prizeGiveType, setPrizeGiveType] = useState<string>("SEED"); // 프라이즈 종류 ('SEED' || ')
  const [totalPrize, setTotalPrize] = useState<number>(0); // 현재 토탈 프라이즈
  const [prizeWay, setPrizeWay] = useState(""); // 상금 종류

  // 스트럭쳐
  const [structures, setStructures] =
    useState<StructuresResponse[]>(defaultStructures);
  const [structureCheckList, setStructureCheckList] = useState<number[]>([]); // 선택된 스트럭쳐 리스트

  // 미사용 컬럼
  const [freeRoll, setFreeRoll] = useState(false);
  const [registerLimitYear, setRegisterLimitYear] = useState(now.getFullYear());
  const [registerLimitMonth, setRegisterLimitMonth] = useState(
    now.getMonth() + 1,
  );
  const [registerLimitDay, setRegisterLimitDay] = useState(now.getDate());
  const [registerLimitHour, setRegisterLimitHour] = useState(now.getHours());
  const [registerLimitMin, setRegisterLimitMin] = useState(now.getMinutes());
  const [prize, setPrize] = useState(80);
  const [reBuyInType, setReBuyInType] = useState<ReBuyInType>(
    ReBuyInType.INDIVIDUAL,
  );
  const [reBuyInCount, setReBuyInCount] = useState(10);
  const [adOnCount, setAdOnCount] = useState(10);

  // 유튜브 라이브
  const [liveList, setLiveList] = useState<YoutubeLiveResponse[]>([]);
  const [allLiveList, setAllLiveList] = useState<YoutubeLiveResponse[]>([]);
  const [isPush, setIsPush] = useState(false);

  // 예약 자동 생성
  const [isReservation, setIsReservation] = useState(false);
  const [reservationImage, setReservationImage] = useState<File | null>(null);

  // 유튜브 라이브 리스트 조회
  const getLiveData = async () => {
    if (!pub) return;
    const res = await getYoutubeLive(pub.id);

    if (res.some((item) => item.tournamentId === tournamentId && item.isLive)) {
      setIsPush(true);
    }

    const list = res.map((item) => {
      if (
        (item.tournamentId || tournamentId) &&
        item.tournamentId === tournamentId
      ) {
        return {
          ...item,
          isLive: true,
        };
      }
      return { ...item, isLive: false, link: "" };
    });

    setLiveList(list);
    setAllLiveList(list);
  };

  useEffect(() => {
    getLiveData();
  }, [tournamentId]);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
    field: keyof StructuresResponse,
  ) => {
    const value = e.target.value.replace(/[^0-9]/g, ""); // 숫자가 아닌 값 제거
    if (isNaN(+value)) {
      alert("0 이상의 수만 입력 가능합니다. ");
      return;
    }
    if (+value > 2147483647) {
      alert("너무 큰 값은 입력할 수 없습니다. ");
      return;
    }
    const updatedStructures: StructuresResponse[] = [...structures];

    if (
      field === "time" ||
      field === "smallBlind" ||
      field === "bigBlind" ||
      field === "ante" ||
      field === "removeChip"
    ) {
      updatedStructures[index][field] = value ? parseInt(value, 10) : 0;
    }

    setStructures(updatedStructures);
  };

  const handleChangeToBreak = (index: number) => {
    const updatedStructures: StructuresResponse[] = [...structures];

    if (updatedStructures[index].type === "LEVEL") {
      updatedStructures[index].type = "BREAK";
      updatedStructures[index].removeChip = 0;
      delete updatedStructures[index].level;
      delete updatedStructures[index].smallBlind;
      delete updatedStructures[index].bigBlind;
      delete updatedStructures[index].ante;
    }
    let level = 1;
    for (let i = 0; i < updatedStructures.length; i++) {
      updatedStructures[i].ord = i + 1;
      if (updatedStructures[i].type === "LEVEL") {
        updatedStructures[i].level = level;
        level++;
      }
    }

    setStructures(updatedStructures);
  };

  const handleChangeToLevel = (index: number) => {
    const updatedStructures: StructuresResponse[] = [...structures];

    if (updatedStructures[index].type === "BREAK") {
      updatedStructures[index].type = "LEVEL";
      updatedStructures[index].smallBlind = 500;
      updatedStructures[index].bigBlind = 1000;
      updatedStructures[index].ante = 0;
      delete updatedStructures[index].removeChip;
    }

    let level = 1;
    for (let i = 0; i < updatedStructures.length; i++) {
      if (updatedStructures[i].type === "LEVEL") {
        updatedStructures[i].level = level;
        level++;
      }
    }

    setStructures(updatedStructures);
  };

  const handleDelete = (index: number) => {
    const updatedStructures: StructuresResponse[] = [...structures];

    updatedStructures.splice(index, 1);

    let level = 1;
    for (let i = 0; i < updatedStructures.length; i++) {
      updatedStructures[i].ord = i + 1;
      if (updatedStructures[i].type === "LEVEL") {
        updatedStructures[i].level = level;
        level++;
      }
    }

    setStructures(updatedStructures);
  };

  const handleAddLevel = () => {
    const lastSelected = structureCheckList[structureCheckList.length - 1];
    const updatedStructures: StructuresResponse[] = [...structures];
    const insertIndex =
      lastSelected !== undefined ? lastSelected + 1 : updatedStructures.length;

    updatedStructures.splice(insertIndex, 0, {
      type: "LEVEL",
      time: 10,
      smallBlind: 500,
      bigBlind: 1000,
      ante: 0,
      ord: 0,
    });

    let level = 1;
    for (let i = 0; i < updatedStructures.length; i++) {
      updatedStructures[i].ord = i + 1;
      if (updatedStructures[i].type === "LEVEL") {
        updatedStructures[i].level = level;
        level++;
      }
    }

    setStructures(updatedStructures);
  };

  const handleAddBreak = () => {
    const lastSelected = structureCheckList[structureCheckList.length - 1];
    const updatedStructures: StructuresResponse[] = [...structures];
    const insertIndex =
      lastSelected !== undefined ? lastSelected + 1 : updatedStructures.length;

    updatedStructures.splice(insertIndex, 0, {
      type: "BREAK",
      time: 10,
      removeChip: 0,
      ord: 0,
    });

    let level = 1;
    for (let i = 0; i < updatedStructures.length; i++) {
      updatedStructures[i].ord = i + 1;
      if (updatedStructures[i].type === "LEVEL") {
        updatedStructures[i].level = level;
        level++;
      }
    }

    setStructures(updatedStructures);
  };

  const handleStructureList = (index: number) => {
    setStructureCheckList((prev) => {
      if (prev.includes(index)) {
        return prev.filter((item) => item !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  const handleMoveTop = (indices: number[]) => {
    const updatedStructures: StructuresResponse[] = [...structures];

    // 상단으로 이동할 레벨들
    const moveItems = indices.map((index) => updatedStructures[index]);
    // null 값 삭제
    const newStructures = moveItems.filter((structure) => structure);

    // 나머지 레벨들
    const remainingStructures = updatedStructures.filter(
      (_, index) => !indices.includes(index),
    );

    // 상단으로 이동할 레벨들 + 나머지 레벨들 => 최종 결과
    const updatedStructuresResult = [...newStructures, ...remainingStructures];

    // 레벨, ord 재정렬
    let level = 1;
    for (let i = 0; i < updatedStructuresResult.length; i++) {
      updatedStructuresResult[i].ord = i + 1;
      if (updatedStructuresResult[i].type === "LEVEL") {
        updatedStructuresResult[i].level = level;
        level++;
      }
    }

    // 선택한 레벨들 그대로 유지
    const newIndices = indices.map((originalIndex) => {
      const originalItem = updatedStructures[originalIndex];
      const newIndex = updatedStructuresResult.findIndex(
        (item) => item === originalItem,
      );
      return newIndex;
    });

    setStructures(updatedStructuresResult);
    setStructureCheckList(newIndices);
  };

  const handleMoveUp = (indices: number[]) => {
    // 저장할 스트럭쳐 배열
    const updatedStructures: StructuresResponse[] = [...structures];
    indices.sort((a, b) => a - b);

    // 선택한 레벨과 그 위 레벨 변경
    indices.forEach((index) => {
      if (index === 0) return;

      const temp = updatedStructures[index];
      updatedStructures[index] = updatedStructures[index - 1];
      updatedStructures[index - 1] = temp;
    });

    // null 값 삭제
    const newStructures = updatedStructures.filter((structure) => structure);

    // 레벨, ord 재정렬
    let level = 1;
    for (let i = 0; i < newStructures.length; i++) {
      newStructures[i].ord = i + 1;
      if (newStructures[i].type === "LEVEL") {
        newStructures[i].level = level;
        level++;
      }
    }

    // 선택한 레벨들 그대로 유지
    let newIndices: number[] = [];
    indices.forEach((index) => {
      if (index > 0) {
        newIndices.push(index - 1);
      }
    });

    setStructures(newStructures);
    setStructureCheckList(newIndices);
  };

  const handleMoveDown = (indices: number[]) => {
    const updatedStructures: StructuresResponse[] = [...structures];
    indices.sort((a, b) => a - b);

    // 선택한 레벨과 그 아래 레벨 변경
    indices.forEach((index) => {
      if (index === structures.length - 1) return;

      const temp = updatedStructures[index];
      updatedStructures[index] = updatedStructures[index + 1];
      updatedStructures[index + 1] = temp;
    });

    // null 값 삭제
    const newStructures = updatedStructures.filter((structure) => structure);

    // 레벨, ord 재정렬
    let level = 1;
    for (let i = 0; i < newStructures.length; i++) {
      newStructures[i].ord = i + 1;
      if (newStructures[i].type === "LEVEL") {
        newStructures[i].level = level;
        level++;
      }
    }

    // 선택한 레벨들 그대로 유지
    let newIndices: number[] = [];
    indices.forEach((index) => {
      if (newStructures.length > index + 1) {
        newIndices.push(index + 1);
      }
    });

    setStructures(newStructures);
    setStructureCheckList(newIndices);
  };

  const handleMoveBottom = (indices: number[]) => {
    const updatedStructures: StructuresResponse[] = [...structures];

    // 하단으로 이동할 레벨들
    const moveItems = indices.map((index) => updatedStructures[index]);
    // null 값 삭제
    const newStructures = moveItems.filter((structure) => structure);

    // 이동하지 않을 레벨들
    const remainingStructures = updatedStructures.filter(
      (_, index) => !indices.includes(index),
    );

    // 스트럭처 저장
    const updatedStructuresResult = [...remainingStructures, ...newStructures];

    // level, ord 재정렬
    let level = 1;
    for (let i = 0; i < updatedStructuresResult.length; i++) {
      updatedStructuresResult[i].ord = i + 1;
      if (updatedStructuresResult[i].type === "LEVEL") {
        updatedStructuresResult[i].level = level;
        level++;
      }
    }

    // 인덱스 재정렬
    const newIndices = indices.map((originalIndex) => {
      const originalItem = updatedStructures[originalIndex];
      const newIndex = updatedStructuresResult.findIndex(
        (item) => item === originalItem,
      );
      return newIndex;
    });

    setStructures(updatedStructuresResult);
    setStructureCheckList(newIndices);
  };

  // 데이터 조회
  const getDataById = async (id: number) => {
    try {
      await getTournamentDetail(id).then((res) => {
        const reducePrize = res.moneyInChip.reduce((acc, item) => {
          return acc + item.point;
        }, 0);
        setTotalPrize(reducePrize);
        setTournamentId(id);
        setEntryUserCount(res.entryUserCount);
        setTitle(res.title);
        setSubTitle(res.subTitle);
        setTournamentType(res.tournamentType);
        const [startDatePart, startTimePart] = res.startDate.split(" ");

        const [registerLimitDatePart, registerLimitTimePart] =
          res.registerLimitDate.split(" ");
        const [registerLimitYear, registerLimitMonth, registerLimitDay] =
          registerLimitDatePart.split("-").map(Number);
        const [registerLimitHour, registerLimitMin] = registerLimitTimePart
          .split(":")
          .map(Number);

        setPrizeGiveType(res.prizeGiveType);
        setStartDate(startDatePart);
        setStartTime(startTimePart);
        setTournamentDiscounts(
          res.tournamentDiscounts ? res.tournamentDiscounts : [],
        );
        setIsTournamentDiscount(res.tournamentDiscounts?.length ? true : false);
        setPrizeWay(res.prizeWay ? res.prizeWay : "");

        setRegisterLimitYear(registerLimitYear);
        setRegisterLimitMonth(registerLimitMonth);
        setRegisterLimitDay(registerLimitDay);
        setRegisterLimitHour(registerLimitHour);
        setRegisterLimitMin(registerLimitMin);
        setFreeRoll(res.freeRoll);
        setEntry(res.entry || 30);
        setBuyIn(res.buyIn || 30000);
        setReBuyIn(res.reBuyIn || res.buyIn || 30000);
        setAddOn(res.addOn || res.buyIn || 30000);
        setBuyInChip(res.buyInChip);
        setReBuyInType(res.reBuyInType);
        setReBuyInCount(res.reBuyInCount);
        setReBuyInChip(res.reBuyInChip);
        setAdOnCount(res.adOnCount);
        setAdOnChip(res.adOnChip);
        setRegisterDeadlineLevel(res.registerDeadlineLevel);
        setEarlyChipSetting(res.earlyChipSetting);
        setUserLimit(res.userLimit ? res.userLimit : 10);
        setEarlyInChip(res.earlyInChip || 60000);
        setLevelLimitChip(res.levelLimitChip);
        setPrize(res.prize);
        setPrizeType(res.prizeType);
        setMoneyInChip(res.moneyInChip);
        setStructures(res.structure);
        setIsAdditional(res.isAdditional ? res.isAdditional : false);
        setAdditional(res.additional ? res.additional : 0);
        setAdditionalList(
          res.additionalList ? JSON.parse(res.additionalList) : [],
        );
        setIsFreezeOut(res.isFreezeOut ? res.isFreezeOut : false);
        setIsDiscountExcluded(res.isDiscountExcluded);
        setTotalDiscount(res.totalDiscount);
      });
    } catch (e) {
      console.log(e);
    }
  };

  // 프리셋 데이터 조회
  const getDataByPreset = async (content: string) => {
    const res = JSON.parse(content);
    setTitle(res.title);
    setSubTitle(res.subTitle);
    const today = new Date();
    const startHour = ("0" + today.getHours()).slice(-2);
    const startMin = ("0" + today.getMinutes()).slice(-2);

    const [registerLimitDatePart, registerLimitTimePart] =
      res.registerLimitDate.split(" ");
    const [registerLimitYear, registerLimitMonth, registerLimitDay] =
      registerLimitDatePart.split("-").map(Number);
    const [registerLimitHour, registerLimitMin] = registerLimitTimePart
      .split(":")
      .map(Number);

    setTournamentType(res.tournamentType);
    setStartDate("");
    setStartTime(`${startHour}:${startMin}`);

    setPrizeWay(res.prizeWay ? res.prizeWay : "");
    setPrizeGiveType(res.prizeGiveType);
    setTournamentDiscounts(
      res.tournamentDiscounts ? res.tournamentDiscounts : [],
    );
    setIsTournamentDiscount(res.tournamentDiscounts?.length ? true : false);
    setRegisterLimitYear(registerLimitYear);
    setRegisterLimitMonth(registerLimitMonth);
    setRegisterLimitDay(registerLimitDay);
    setRegisterLimitHour(registerLimitHour);
    setRegisterLimitMin(registerLimitMin);
    setFreeRoll(res.freeRoll);
    setEntry(res.entry > 2147483647 ? 2147483647 : res.entry || 30);
    setBuyIn(res.buyIn || 30000);
    setReBuyIn(res.reBuyIn || res.buyIn || 30000);
    setAddOn(res.addOn || res.buyIn || 30000);
    setBuyInChip(res.buyInChip);
    console.log(res.buyInChip);
    setReBuyInType(res.reBuyInType);
    setReBuyInCount(res.reBuyInCount);
    setReBuyInChip(res.reBuyInChip);
    setAdOnCount(res.adOnCount);
    setAdOnChip(res.adOnChip);
    setRegisterDeadlineLevel(res.registerDeadlineLevel);
    setEarlyChipSetting(res.earlyChipSetting);
    setUserLimit(res.userLimit ? res.userLimit : 10);
    setEarlyInChip(res.earlyInChip || 60000);
    setLevelLimitChip(res.levelLimitChip);
    setPrize(res.prize);
    setPrizeType(res.prizeType === "" ? "SEED" : res.prizeType);

    setMoneyInChip(
      res.moneyInChip.map((item: MoneyInChip) => ({
        ...item,
        id: null,
        tournamentId: null,
      })),
    );
    setStructures(res.structure);
    setIsAdditional(res.isAdditional ? res.isAdditional : false);
    setAdditional(res.additional ? res.additional : 0);
    setAdditionalList(res.additionalList ? JSON.parse(res.additionalList) : []);
    setIsFreezeOut(res.isFreezeOut ? res.isFreezeOut : false);
  };

  // 데이터 리셋
  const resetData = async () => {
    setSelectedPresetId(null);
    setTitle("");
    setSubTitle("");
    setTournamentType(TournamentType.Tournament);
    setPrizeWay("");
    setPrizeGiveType("");
    const today = new Date();
    const startHour = ("0" + today.getHours()).slice(-2);
    const startMin = ("0" + today.getMinutes()).slice(-2);
    setStartDate("");
    setStartTime(`${startHour}:${startMin}`);
    setFreeRoll(false);
    setEntry(0);
    setBuyIn(30000);
    setReBuyIn(30000);
    setAddOn(30000);
    setBuyInChip(50000);
    setReBuyInType(ReBuyInType.INDIVIDUAL);
    setReBuyInCount(10);
    setReBuyInChip(50000);
    setAdOnCount(10);
    setAdOnChip(50000);
    setRegisterDeadlineLevel(0);
    setEarlyChipSetting(EarlyChipSettingType.NONE);
    setUserLimit(0);
    setEarlyInChip(0);
    setLevelLimitChip([
      { level: 1, chip: 0 },
      { level: 2, chip: 0 },
      { level: 3, chip: 0 },
    ]);
    setPrize(80);
    setPrizeType("");
    setTournamentDiscounts([
      { level: 1, amount: 0 },
      { level: 2, amount: 0 },
      { level: 3, amount: 0 },
    ]);
    setMoneyInChip([
      { rank: 1, point: 0, subPrize: "", prizeType: null, isSubPrize: false },
      { rank: 2, point: 0, subPrize: "", prizeType: null, isSubPrize: false },
      { rank: 3, point: 0, subPrize: "", prizeType: null, isSubPrize: false },
      { rank: 4, point: 0, subPrize: "", prizeType: null, isSubPrize: false },
      { rank: 5, point: 0, subPrize: "", prizeType: null, isSubPrize: false },
    ]);
    setStructures(defaultStructures);
    setIsAdditional(false);
    setAdditional(0);
    setAdditionalList([]);
    setIsFreezeOut(false);
  };

  const formatDateTime = () => {
    return `${startDate} ${startTime}`;
  };

  const checkInput = (checkTime: boolean) => {
    // 공통 체크 항목
    if (isNaN(entry)) {
      alert("0 이상의 수만 입력 가능합니다. ");
      return false;
    }
    if (checkTime && !startDate) {
      alert("날짜를 선택해주세요. ");
      return false;
    }

    if (entry > 2147483647) {
      alert("너무 큰 값은 입력할 수 없습니다. ");
      return false;
    }
    if (title === "") {
      alert("타이틀을 입력해주세요.");
      return false;
    }
    if (subTitle === "") {
      alert("서브타이틀을 입력해주세요.");
      return false;
    }

    if (prizeType === "" && prizeGiveType !== "ALL") {
      alert("상금 표기 방식을 입력해주세요.");

      return false;
    }
    if (prizeWay === "") {
      alert("상금 종류를 입력해주세요.");
      return false;
    }

    if (title && title.length >= 255) {
      alert("토너먼트 타이틀이 너무 깁니다. ");
      return false;
    }

    if (subTitle && subTitle.length >= 255) {
      alert("토너먼트 서브 타이틀이 너무 깁니다. ");
      return false;
    }

    // 만단위만 생성 가능
    const isValidUnit = (value: number) => value % 10000 === 0;

    if (isTournamentDiscount) {
      for (const discount of tournamentDiscounts) {
        if (discount.amount > buyIn) {
          alert("할인 값이 참가 금액을 초과하여 수정이 불가능합니다. ");
          return false;
        }
        if (!isValidUnit(discount.amount)) {
          alert("할인 값은 만 단위여야 합니다.");
          return false;
        }
      }
    }
    if (registerDeadlineLevel <= 0) {
      alert("레벨 마감 레벨을 0보다 큰 수로 입력해주세요.");
      return false;
    }

    if (moneyInChip.length === 0) {
      alert("머니인 정보는 최소 1개 이상 입력해주세요.");
      return false;
    }

    // 이벤트 제외 체크 항목
    if (isEventType(tournamentType)) return true;

    if (moneyInChip.reduce((acc, item) => acc + item.point, 0) <= 0) {
      alert("상금은 1 이상 입력해주세요.");
      return false;
    }

    if (moneyInChip && moneyInChip.some((prize) => prize.point === 0)) {
      if (
        additionalList &&
        additionalList.some(
          (item, index) => item.prize + moneyInChip[index].point === 0,
        )
      ) {
        alert("프라이즈를 모두 입력해주세요. ");
        return false;
      } else if (additionalList.length === 0) {
        alert("프라이즈를 모두 입력해주세요. ");
        return false;
      } else if (!isAdditional) {
        alert("프라이즈를 모두 입력해주세요. ");
        return false;
      }
    }

    // GTD 체크 항목
    if (entry <= 0 && isGTDType(tournamentType)) {
      alert("기준 엔트리를 0 이상의 수로 입력 해주세요.");
      return false;
    }

    // 데일리 체크 항목
    if (isDailyType(tournamentType)) {
      let result = 0;
      moneyInChip.forEach((item) => {
        result += +item.point;
      });
      if (result > 80) {
        alert("프라이즈 총 합 80%를 초과할 수 없습니다. ");
        return false;
      }
    }

    if (structures.length <= 0) {
      alert("스트럭쳐를 추가해주세요. ");
      return false;
    }

    if (!isValidUnit(buyIn) || !isValidUnit(reBuyIn) || !isValidUnit(addOn)) {
      alert("결제 금액은 만 단위여야 합니다.");
      return false;
    }
    return true;
  };

  // 토너먼트 생성
  const registerStructure = async () => {
    if (!pub) return null;
    const checking = checkInput(true);
    if (!checking) return null;

    const date = new Date();
    const start = new Date(formatDateTime());
    const playTime = date.getTime() - start.getTime();
    if (playTime > 0) {
      alert("현재 시간보다 과거로 시작시간을 설정할 수 없습니다. ");
      return null;
    }

    const oneYearLater = new Date(date.getTime() + 365 * 24 * 60 * 60 * 1000);
    if (start > oneYearLater) {
      alert("1년 후의 토너먼트는 생성할 수 없습니다.");
      return null;
    }

    let formatMoneyInChip = moneyInChip;

    formatMoneyInChip = moneyInChip.map((item) => {
      return {
        ...item,
        prizeType: "SEED",
      };
    });
    if (isEventType(tournamentType)) {
      formatMoneyInChip = moneyInChip.map((item) => {
        return {
          ...item,
          isSubPrize: true,
        };
      });
    }
    const newAdditionalList: AddPrize[] = [];
    for (let i = 0; i < moneyInChip.length; i++) {
      newAdditionalList.push({ rank: i + 1, prize: 0 });
    }

    const newLiveList = allLiveList.filter((live) => live.isLive);
    const youtubeLiveList: YoutubeLiveRequest[] = newLiveList.map((item) => {
      return {
        attendeeId: item.attendeeId || 0,
        link: item.link || "",
        order: item.order || 0,
      };
    });

    const request: TournamentRequest = {
      cafeId: pub.id,
      title,
      subTitle,
      tournamentType,
      startDate: formatDateTime(),
      freeRoll,
      entry: !freeRoll ? entry : null,
      buyIn: !freeRoll ? buyIn : null,
      reBuyIn: reBuyIn,
      addOn: addOn,
      buyInChip,
      reBuyInType,
      reBuyInCount,
      reBuyInChip,
      adOnCount,
      adOnChip,
      registerDeadlineLevel,
      earlyChipSetting,
      userLimit:
        earlyChipSetting === EarlyChipSettingType.USER_LIMIT ? userLimit : null,
      earlyInChip:
        earlyChipSetting === EarlyChipSettingType.USER_LIMIT
          ? earlyInChip
          : null,
      levelLimitChip:
        earlyChipSetting === EarlyChipSettingType.LEVEL_LIMIT
          ? levelLimitChip
          : null,
      prize,
      prizeType,
      moneyInChip: formatMoneyInChip,
      registerLimitDate: `${registerLimitYear}-${registerLimitMonth}-${registerLimitDay} ${registerLimitHour}:${registerLimitMin}`,
      structure: structures,
      additional,
      isAdditional,
      additionalList: JSON.stringify(newAdditionalList),
      isFreezeOut,
      prizeGiveType,
      prizeWay,
      useSolution: true,
      isDiscountExcluded,
      youtubeLiveList,
      tournamentDiscounts: isTournamentDiscount ? tournamentDiscounts : [],
      isReservation,
    };

    const formData = new FormData();
    // 파일 데이터 추가
    formData.append("image", reservationImage || "");

    // JSON 데이터를 문자열로 변환하여 추가
    formData.append("data", JSON.stringify(request));

    try {
      const res = await registerTournament(pub.id, formData);
      return res;
    } catch (e: any) {
      return e;
    }
  };

  // 프리셋 수정
  const updateStructurePreset = async (id: number) => {
    if (!pub) return;
    const checking = checkInput(false);
    if (!checking) return false;
    const request: TournamentRequest = {
      cafeId: pub.id,
      title,
      subTitle,
      tournamentType,
      startDate: formatDateTime(),
      freeRoll,
      entry: !freeRoll ? entry : null,
      buyIn: !freeRoll ? buyIn : null,
      reBuyIn: reBuyIn,
      addOn: addOn,
      buyInChip,
      reBuyInType,
      reBuyInCount,
      reBuyInChip,
      adOnCount,
      adOnChip,
      registerDeadlineLevel,
      earlyChipSetting,
      userLimit:
        earlyChipSetting === EarlyChipSettingType.USER_LIMIT ? userLimit : 0,
      earlyInChip:
        earlyChipSetting === EarlyChipSettingType.USER_LIMIT
          ? earlyInChip
          : 50000,
      levelLimitChip:
        earlyChipSetting === EarlyChipSettingType.LEVEL_LIMIT
          ? levelLimitChip
          : [],
      prize,
      prizeType,
      moneyInChip,
      registerLimitDate: `${registerLimitYear}-${registerLimitMonth}-${registerLimitDay} ${registerLimitHour}:${registerLimitMin}`,
      structure: structures,
      additional,
      isAdditional,
      additionalList: JSON.stringify(additionalList),
      isFreezeOut,
      prizeWay,
      prizeGiveType,
      tournamentDiscounts: isTournamentDiscount ? tournamentDiscounts : [],
      isDiscountExcluded,
      useSolution: true,
    };
    const body = {
      cafeId: pub.id,
      preset: JSON.stringify(request),
    };
    await updateTournamentPreset(id, body);
    return true;
  };

  // 프리셋 생성
  const registerStructurePreset = async (presetName: string) => {
    if (!pub) return;
    const request: TournamentRequest = {
      cafeId: pub.id,
      title,
      subTitle,
      tournamentType,
      startDate: formatDateTime(),
      freeRoll,
      entry: !freeRoll ? entry : null,
      buyIn: !freeRoll ? buyIn : null,
      reBuyIn: reBuyIn,
      addOn: addOn,
      buyInChip,
      reBuyInType,
      reBuyInCount,
      reBuyInChip,
      adOnCount,
      adOnChip,
      registerDeadlineLevel,
      earlyChipSetting,
      userLimit:
        earlyChipSetting === EarlyChipSettingType.USER_LIMIT ? userLimit : 0,
      earlyInChip:
        earlyChipSetting === EarlyChipSettingType.USER_LIMIT
          ? earlyInChip
          : 50000,
      levelLimitChip:
        earlyChipSetting === EarlyChipSettingType.LEVEL_LIMIT
          ? levelLimitChip
          : [],
      prize,
      prizeType,
      moneyInChip,
      registerLimitDate: `${registerLimitYear}-${registerLimitMonth}-${registerLimitDay} ${registerLimitHour}:${registerLimitMin}`,
      structure: structures,
      additional,
      isAdditional,
      additionalList: JSON.stringify(additionalList),
      isFreezeOut,
      prizeWay,
      prizeGiveType,
      tournamentDiscounts: isTournamentDiscount ? tournamentDiscounts : [],
      isDiscountExcluded,
      useSolution: true,
    };
    const body = {
      cafeId: pub.id,
      presetName,
      preset: JSON.stringify(request),
    };
    const res = await registerTournamentPreset(body);
    return res;
  };

  // 토너먼트 수정
  const updateStructure = async (id: number) => {
    if (!pub) return;
    const checking = checkInput(true);
    if (!checking) return null;

    if (!isTournamentAccess(id, pub.tournamentIds)) {
      alert(`토너먼트 ID ${id}에 대한 권한이 없습니다. `);
      return null;
    }

    const currentReduce = moneyInChip.reduce(
      (acc, item) => acc + item.point,
      0,
    );

    if (totalPrize < currentReduce && entryUserCount > 0) {
      alert("프라이즈를 늘릴 수 없습니다. ");
      return null;
    }
    const result = moneyInChip.reduce((acc, item) => acc + item.point, 0);
    if (
      (isGTDType(tournamentType) || isDailyType(tournamentType)) &&
      totalPrize > result &&
      entryUserCount > 0
    ) {
      alert("기존 프라이즈 총합보다 낮게 설정할 수 없습니다. ");
      return null;
    }

    let formatMoneyInChip = moneyInChip;
    formatMoneyInChip = moneyInChip.map((item) => {
      return {
        ...item,
        prizeType: "SEED",
      };
    });
    if (isEventType(tournamentType)) {
      formatMoneyInChip = moneyInChip.map((item) => {
        return {
          ...item,
          isSubPrize: true,
        };
      });
    }

    const newLiveList = allLiveList.filter((live) => live.isLive);
    const youtubeLiveList: YoutubeLiveRequest[] = newLiveList.map((item) => {
      return {
        attendeeId: item.attendeeId || 0,
        link: item.link || "",
        order: item.order || 0,
      };
    });

    const request: TournamentRequest = {
      title,
      subTitle,
      tournamentType,
      startDate: formatDateTime(),
      freeRoll,
      entry: !freeRoll ? entry : null,
      buyIn: !freeRoll ? buyIn : null,
      reBuyIn: reBuyIn,
      addOn: addOn,
      buyInChip,
      reBuyInType,
      reBuyInCount,
      reBuyInChip,
      adOnCount,
      adOnChip,
      registerDeadlineLevel,
      earlyChipSetting,
      userLimit:
        earlyChipSetting === EarlyChipSettingType.USER_LIMIT ? userLimit : null,
      earlyInChip:
        earlyChipSetting === EarlyChipSettingType.USER_LIMIT
          ? earlyInChip
          : null,
      levelLimitChip:
        earlyChipSetting === EarlyChipSettingType.LEVEL_LIMIT
          ? levelLimitChip
          : null,
      prize,
      prizeType,
      moneyInChip: formatMoneyInChip,
      registerLimitDate: `${registerLimitYear}-${registerLimitMonth}-${registerLimitDay} ${registerLimitHour}:${registerLimitMin}`,
      structure: structures,
      additional,
      isAdditional,
      additionalList: JSON.stringify(additionalList),
      isFreezeOut,
      prizeWay,
      prizeGiveType,
      useSolution: true,
      isDiscountExcluded,
      cafeId: pub.id,
      youtubeLiveList,
      tournamentDiscounts: isTournamentDiscount ? tournamentDiscounts : [],
    };
    try {
      const res = await updateTournament(id, request);
      return res;
    } catch (e: any) {
      if (e.status === 403) {
        alert(e.response.data.message);
        return e;
      }
      return e;
    }
  };

  return {
    title,
    setTitle,
    subTitle,
    setSubTitle,
    tournamentType,
    setTournamentType,
    startDate,
    setStartDate,
    startTime,
    setStartTime,
    prizeGiveType,
    setPrizeGiveType,
    entry,
    setEntry,
    buyIn,
    setBuyIn,
    reBuyIn,
    setReBuyIn,
    addOn,
    setAddOn,
    buyInChip,
    setBuyInChip,
    reBuyInChip,
    setReBuyInChip,
    adOnChip,
    setAdOnChip,
    registerDeadlineLevel,
    setRegisterDeadlineLevel,
    earlyChipSetting,
    setEarlyChipSetting,
    userLimit,
    setUserLimit,
    earlyInChip,
    setEarlyInChip,
    levelLimitChip,
    setLevelLimitChip,
    prizeType,
    setPrizeType,
    moneyInChip,
    setMoneyInChip,
    // 핸들러 ==========================
    resetData,
    // 프리셋
    getDataByPreset,
    updateStructurePreset,
    registerStructurePreset,
    // 토너먼트 데이터
    getDataById,
    updateStructure,
    registerStructure,
    // 스트럭쳐
    handleMoveTop,
    handleMoveBottom,
    handleStructureList,
    handleDelete,
    handleMoveUp,
    handleMoveDown,
    handleInputChange,
    handleChangeToBreak,
    handleChangeToLevel,
    handleAddLevel,
    handleAddBreak,
    structures,
    setStructures,
    // 스트럭쳐 위치 이동 리스트
    structureCheckList,
    // 수정할 토너먼트 id
    tournamentId,
    setTournamentId,
    // 추가 시상
    additional,
    setAdditional,
    isAdditional,
    setIsAdditional,
    additionalList,
    setAdditionalList,
    // 프라이즈 아웃
    isFreezeOut,
    setIsFreezeOut,
    // 상금 종류
    prizeWay,
    setPrizeWay,
    // 프리셋 선택
    selectedPresetId,
    setSelectedPresetId,
    // 데일리 토너먼트 할인 제외
    isDiscountExcluded,
    setIsDiscountExcluded,
    totalDiscount,
    // 유튜브 라이브
    liveList,
    setLiveList,
    allLiveList,
    setAllLiveList,
    isPush,
    setIsPush,
    // 토너먼트 할인 설정
    tournamentDiscounts,
    setTournamentDiscounts,
    isTournamentDiscount,
    setIsTournamentDiscount,
    // 예약 설정
    isReservation,
    setIsReservation,
    reservationImage,
    setReservationImage,
  };
};
